import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useParams } from "react-router-dom";
import { JsonLd, websiteSchema } from "../components/seo/JsonLd";
import { SITE_URL, parseLocale } from "../lib/locale";
import { Footer } from "./Footer";
import { Navbar } from "./Navbar";

export function MainLayout() {
  const { lang: raw } = useParams();
  const lang = parseLocale(raw);
  const { i18n, t } = useTranslation();

  useEffect(() => {
    void i18n.changeLanguage(lang);
    document.documentElement.lang = lang === "pt" ? "pt-PT" : "en";
  }, [lang, i18n]);

  return (
    <>
      <JsonLd data={websiteSchema(SITE_URL)} />
      <a
        href="#main"
        className="bx-focus sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded focus:px-3 focus:py-2 focus:text-white"
        style={{ backgroundColor: "var(--color-primary)" }}
      >
        {t("a11y.skip")}
      </a>
      <Navbar />
      <main id="main">
        <Outlet />
      </main>
      <Footer name="Nuno Semedo" showYear />
    </>
  );
}
